export default __webpack_public_path__ + "static/media/PropertyDev_Shapes-01-3.32c91b36.png";